import { render } from "./ReportUserDetails.vue?vue&type=template&id=2d949c4c&ts=true"
import script from "./ReportUserDetails.vue?vue&type=script&lang=ts"
export * from "./ReportUserDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__